// $("#cookiebarSettings").click(function() {
//     $(".cookiebarOverlay").toggleClass("top");
//     $(".cookiebarAside").toggleClass("open");
// });
